@if (loading) {
  <div class="inline-loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading BAA...</p>
  </div>
}

@if (!loading && !baa) {
  <div class="inline-empty">
    <mat-icon>policy</mat-icon>
    <p>BAA not found</p>
  </div>
}

@if (!loading && baa) {
  <div class="inline-detail-container">

    <!-- Header -->
    <div class="inline-header">
      <div class="inline-header-info">
        <h3>
          <mat-icon>policy</mat-icon>
          Business Associate Agreement
        </h3>
        <div class="inline-metadata">
          <span class="meta-item">ID: {{ baa.baaId || 'N/A' }}</span>
          @if (baa.baaNum) {
            <span class="meta-separator">|</span>
            <span class="meta-item">Number: {{ baa.baaNum }}</span>
          }
          @if (baa.status) {
            <mat-chip-set>
              <mat-chip [highlighted]="baa.status === 'Active'">
                {{ baa.status }}
              </mat-chip>
            </mat-chip-set>
          }
        </div>
      </div>
      <div class="inline-header-actions">
        @if (document) {
          <button mat-stroked-button (click)="toggleDocument()">
            <mat-icon>{{ showDocument ? 'visibility_off' : 'visibility' }}</mat-icon>
            {{ showDocument ? 'Hide' : 'View' }} Document
          </button>
        }
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Info Grid -->
    <div class="inline-info-grid">
      <div class="inline-info-field">
        <label>Business Associate</label>
        <div class="value">{{ businessAssociateName }}</div>
      </div>

      <div class="inline-info-field">
        <label>Covered Entity</label>
        <div class="value">{{ coveredEntityName }}</div>
      </div>

      <div class="inline-info-field">
        <label>Primary Owner</label>
        <div class="value">{{ primaryOwnerName }}</div>
      </div>

      <div class="inline-info-field">
        <label>Effective Date</label>
        <div class="value">{{ formatDate(baa.effectiveDate) }}</div>
      </div>

      <div class="inline-info-field">
        <label>Expiration Date</label>
        <div class="value">{{ formatDate(baa.expirationDate) }}</div>
      </div>

      <div class="inline-info-field">
        <label>Execution Date</label>
        <div class="value">{{ formatDate(baa.executionDate) }}</div>
      </div>

      @if (baa.initialTerm) {
        <div class="inline-info-field">
          <label>Initial Term</label>
          <div class="value">{{ baa.initialTerm }} months</div>
        </div>
      }

      @if (baa.renewalType) {
        <div class="inline-info-field">
          <label>Renewal Type</label>
          <div class="value">{{ baa.renewalType }}</div>
        </div>
      }

      @if (baa.typesOfService && baa.typesOfService.length > 0) {
        <div class="inline-info-field full-width">
          <label>Types of Service</label>
          <div class="value">{{ baa.typesOfService.join(', ') }}</div>
        </div>
      }
    </div>

    <!-- Document Viewer -->
    @if (showDocument && document) {
      <mat-divider></mat-divider>
      <div class="inline-document-viewer">
        @if (document.isPdf || document.isImage || document.isOfficeDocument) {
          <iframe [src]="document.safeViewerUrl"
                  class="document-iframe"
                  [title]="document.fileName">
          </iframe>
        } @else {
          <div class="unsupported-file">
            <mat-icon>description</mat-icon>
            <p>Preview not available for this file type</p>
            <button mat-raised-button (click)="downloadDocument()">
              <mat-icon>download</mat-icon>
              Download
            </button>
          </div>
        }
      </div>
    }

  </div>
}
